import { render, staticRenderFns } from "./UpdateAttendanceGroup.vue?vue&type=template&id=0d95ba56&scoped=true"
import script from "./UpdateAttendanceGroup.vue?vue&type=script&lang=js"
export * from "./UpdateAttendanceGroup.vue?vue&type=script&lang=js"
import style0 from "./UpdateAttendanceGroup.vue?vue&type=style&index=0&id=0d95ba56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95ba56",
  null
  
)

export default component.exports